const MEDIA_GRID_SM = '600px';
const MEDIA_GRID_MD = '900px';
const MEDIA_GRID_LG = '1160px';
const MEDIA_GRID_XL = '1760px';

const SEO_SERVICES = 65,
    SOCIAL_MEDIA_MARKETING = 67,
    SEARCH_ENGINE_MARKETING = 200,
    WHITEBOARD_EXPLAINER_VIDEOS = 228,
    ANIMATED_GIFS = 356,
    BOOK_EBOOK_WRITING = 354,
    SPOKESPERSON = 101,
    VISUAL_EFFECTS = 344,
    LIVE_ACTION_EXPLAINERS = 330;

const ACTIVE_FILTER_SEPARATORS = {
    PARAMS: '|',
    PARAM_VALUE: ':',
    ARRAY_VALUE: ',',
    PAIR_VALUE: '-'
};

const SERIALIZE_LOG_OBJECT_DELIMETERS = {
    ARRAY_DELIMETER: ',',
    KEY_VALUE_DELIMETER: ':',
    PAIRS_DELIMETER: '|'
};

const FLOWS = {
    CATEGORY: 'category',
    SEARCH: 'search'
};

const HANDLERS = {
    SSR: 'ssr',
    AJAX: 'ajax'
};

const CAROUSEL_SOURCES = {
    YOUR_RECENTLY_VIEWED_GIGS: 'your_recently_viewed_gigs'
};

const CONTEXT_PARAMS_DEFAULTS = {
    page_size: 48,
    page: 1,
    offset: 0,
    view_type: 'grid'
};

const SUB_CATEGORY = {
    EXPLAINER_VIDEO: 'https://fiverr-res.cloudinary.com/video/upload/v1564303959/general_assets/categories/videos/fiverr_how_it_works_2.mp4'
};

const SEPARATE_VIDEOS_LINKS = {
    [SEO_SERVICES]: 'https://fiverr-res.cloudinary.com/video/upload/v1534171194/subcategory_explanation_videos/seo.mov',
    [SOCIAL_MEDIA_MARKETING]: 'https://fiverr-res.cloudinary.com/video/upload/v1534171194/subcategory_explanation_videos/social_media_marketing.mov',
    [SEARCH_ENGINE_MARKETING]: 'https://fiverr-res.cloudinary.com/video/upload/v1534171194/subcategory_explanation_videos/search_and_display.mov',
    [WHITEBOARD_EXPLAINER_VIDEOS]: 'https://fiverr-res.cloudinary.com/video/upload/v1534171194/subcategory_explanation_videos/whiteboard_and_animated_explainers.mov',
    [ANIMATED_GIFS]: 'https://fiverr-res.cloudinary.com/video/upload/v1555506239/subcategory_explanation_videos/animated_gifs.mp4',
    [BOOK_EBOOK_WRITING]: 'https://fiverr-res.cloudinary.com/video/upload/v1555506355/subcategory_explanation_videos/book_ebook_writing.mp4',
    [SPOKESPERSON]: 'https://fiverr-res.cloudinary.com/video/upload/v1555506486/subcategory_explanation_videos/spokesperson_videos.mov',
    [VISUAL_EFFECTS]: 'https://fiverr-res.cloudinary.com/video/upload/v1555506400/subcategory_explanation_videos/visual_effects.mov',
    [LIVE_ACTION_EXPLAINERS]: 'https://fiverr-res.cloudinary.com/video/upload/v1555506532/subcategory_explanation_videos/live_action_exaplainers.mp4'
};

const USD_CURRENCY = 'USD';

const REPORT_DATA = {
    MAIN: {
        group: 'algos',
        type: 'listings_impression'
    },
    LISTINGS: {
        now_toggle_exists: false,
        now_toggle_used: false,
        pro_toggle_exists: false,
        pro_toggle_used: false,
        view_type: 'grid'
    }
};

const CAROUSEL_POSITIONS = {
    MAIN: 1,
    YOUR_RECENTLY_VIEWED_GIGS: 2
};

const EVENTS_MAPPING = {
    PAGE_VIEWED: {
        mixpanel: 'Viewed page'
    },
    PAGE_CHANGE: {
        mixpanel: 'Paginate'
    },
    FILTERS_APPLY: {
        mixpanel: 'Filtered by',
        biquery: 'applied_filter'
    },
    FILTER_REMOVE: {
        mixpanel: 'Removed filter',
        biquery: 'cleared_filter'
    },
    FILTERS_CLEAR_ALL: {
        mixpanel: 'Cleared filters',
        biquery: 'cleared_entire_filters'
    },
    SORT_CHANGE: {
        mixpanel: 'Sort changed',
        biquery: 'changed_sort_by'
    },
    CLICKED_WIZARD: {
        mixpanel: 'Clicked Wizard',
        biquery: 'Clicked Wizard'
    },
    CLICKED_RESTART_WIZARD: {
        mixpanel: 'Clicked restart wizard'
    },
    CLICKED_REOPEN_WIZARD: {
        mixpanel: 'Clicked open wizard'
    },
    VIEWED_WIZARD: {
        mixpanel: 'Viewed Wizard'
    },
    CLICKED_CLOSE_WIZARD: {
        mixpanel: 'Clicked close wizard'
    },
    COMPLETED_WIZARD: {
        mixpanel: 'Completed wizard'
    },
    VIEWED_RELATED_SEARCH_TERMS: {
        mixpanel: 'Viewed related search terms'
    },
    CLICK: {
        mixpanel: 'Clicked',
        TARGETS: {
            TOP_FILTER: 'Top Filter: ',
            TOP_FILTERS_NOTIFICATION_CLOSE: 'Floating Filter Notification Close',
            MORE_FILTERS: 'Top Filter: More Filters',
            SUB_CATEGORY_FILTER: 'Sub Categories Filter',
            NESTED_SUB_CATEGORY_NAV: 'Nested Sub Categories nav',
            HOW_FIVERR_WORKS_VIDEO: 'How Fiverr Works Video In SubCategory',
            SHOW_FILTER_RESULTS: 'Show Filter Results'
        }
    }
};

const FILTERS_LOCATION = {
    TOP: 'Top',
    FLOATING_TOP: 'Floating top',
    CLEAR_FLOATING_TOP: 'Clear Floating top',
    CLEAR_FLOATING_TOP_MORE: 'Clear Floating top (more filters)',
    CLEAR_FLOATING_TOP_GROUP: 'Clear Floating top (filter group)',
    MORE_FILTERS: 'More filters',
    SIDEBAR: 'SideBar',
    SELECTED: 'Selected',
    MOBILE_CLEAR_ALL: 'mobile clear all'
};

const WIZARD_BQ_DATA = {
    'type': 'v4_wizard',
    'group': 'other',
    'listings': {
        context: 'sub_categories'
    }
};

const REQUEST_CONTEXT_FIELDS = [
    'query',
    'flow',
    'currentUser',
    'currency',
    'isTouch',
    'categoryIds',
    'user_country',
    'source',
    'view_type',
    'loggedIn',
    'categoryName',
    'subCategoryName',
    'nestedSubCategoryName',
    'should_suggest',
    'showListViewCards',
    'staticFilters',
    'searchAutoComplete',
    'recommendedSubCategoryId',
    'cachedSlug',
    'dominateSubCategoryId',
    'ab_tests'
];

const REQUEST_CONTEXT_DEFAULTS = {
    query: '',
    staticFilters: {}
};

const FULL_INDEX_SIZE = 10;
const HALF_INDEX_SIZE = FULL_INDEX_SIZE / 2;

const DEFAULT_GOFOR_OPTIONS = { method: 'GET'};
const DEFAULT_GOFOR_RETIRES = 3;

const SEARCH_DID_YOU_MEAN_SOURCE = 'search_did_you_mean'; // todo arrange sources under a single const
const BREADCRUMBS_SOURCE = 'breadcrumbs';
const HOME_TITLE = 'fiverr';
const SEARCH_AUTOCOMPLETE = 'search-autocomplete';
const SEARCH_AUTOCOMPLETE_ORIGINAL_TERM = `${SEARCH_AUTOCOMPLETE}-original-term`;

const SEARCH_AUTOCOMPLETE_MAPPING = {
    [SEARCH_AUTOCOMPLETE_ORIGINAL_TERM]: () => ['autocomplete_original_term'],
    [`${SEARCH_AUTOCOMPLETE}-type`]: () => ['autocomplete_type'],
    [`${SEARCH_AUTOCOMPLETE}-position`]: (pos) => ['autocomplete_position', pos && Number(pos)],
    [`${SEARCH_AUTOCOMPLETE}-available`]: (isAvailable) => ['is_autocomplete', !!isAvailable]
};

const PERSEUS_ERROR_TYPES = {
    OOPS_PAGE_ERROR: 'oopsPageError'
};

const LOG_LEVELS = {
    ERROR: 'error',
    WARN: 'warn'
};

const STATUS_CODES = {
    BAD_REQUEST: 400
};

const TOPBAR_OFFSET = 86;

const SORT_BY = 'sort-by';

module.exports = {
    ACTIVE_FILTER_SEPARATORS,
    SERIALIZE_LOG_OBJECT_DELIMETERS,
    FULL_INDEX_SIZE,
    HALF_INDEX_SIZE,
    FLOWS,
    CONTEXT_PARAMS_DEFAULTS,
    SUB_CATEGORY,
    SEPARATE_VIDEOS_LINKS,
    USD_CURRENCY,
    REPORT_DATA,
    CAROUSEL_POSITIONS,
    WIZARD_BQ_DATA,
    HOME_TITLE,
    BREADCRUMBS_SOURCE,
    SEARCH_DID_YOU_MEAN_SOURCE,
    REQUEST_CONTEXT_FIELDS,
    REQUEST_CONTEXT_DEFAULTS,
    DEFAULT_GOFOR_RETIRES,
    DEFAULT_GOFOR_OPTIONS,
    MEDIA_GRID_SM,
    MEDIA_GRID_MD,
    MEDIA_GRID_LG,
    MEDIA_GRID_XL,
    SEARCH_AUTOCOMPLETE,
    SEARCH_AUTOCOMPLETE_ORIGINAL_TERM,
    SEARCH_AUTOCOMPLETE_MAPPING,
    FILTERS_LOCATION,
    EVENTS_MAPPING,
    CAROUSEL_SOURCES,
    HANDLERS,
    PERSEUS_ERROR_TYPES,
    STATUS_CODES,
    TOPBAR_OFFSET,
    SORT_BY,
    LOG_LEVELS
};
